import 'react-perfect-scrollbar/dist/css/styles.css';
import React from 'react';
import {
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import Login from './components/login/Login';
import LoginAdmin from './components/login/LoginAdmin';
import Schema from './components/dashboard/vacuumBag/Schema';
import Report from './components/dashboard/Report';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminConsoles from './components/admin/AdminConsoles';
import AdminConsolesEdit from './components/admin/AdminConsolesEdit';
import Statistics from './components/statistics/Statistics';
import Users from './components/users/Users';
import Error404Account from './components/error404/Error404Account';
import Error404Admin from './components/error404/Error404Admin';
import Error404 from './components/error404/Error404';
import './App.css';
import RepairsDetailed from './components/dashboard/tables/RepairsDetailed';
import Charts from './components/dashboard/charts/Charts';
import TabsDivider from './components/dashboard/TabsDivider';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'var(--app-bg)',
    position: 'absolute',
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('md')]: {
      paddingLeft: 256
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

function App() {
  const classes = useStyles();
  
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Switch>
              {/* ------------- LOGIN PAGES ------------- */}
              <Route exact path='/login' component={Login} />
              <Route exact path='/loginadmin' component={LoginAdmin} />
              {/* ------------- ADMIN PAGES ------------- */}
              <Route exact path='/admin/dashboard' component={AdminDashboard} />
              <Route exact path='/admin/consoles' component={AdminConsoles} />
              <Route exact path='/admin/consolesedit/:uuid' component={AdminConsolesEdit} />
              {/* ------------- CUSTOMERS PAGES ------------- */}
              <Route exact path='/app/reportconfig' component={Report} />
              <Route exact path='/app/repairsdetailed/:uuid' component={RepairsDetailed} />
              <Route exact path='/app/schema' component={Schema} />
              <Route exact path='/app/statistics' component={Statistics} />
              <Route exact path='/app/charts' component={Charts} />
              <Route exact path='/app/users' component={Users} />
              <Route exact path='/app/divider/:uuid' component={TabsDivider} />

              {/* ------------- ERROR404 PAGES ------------- */}
              <Route exact path='/app/*' component={Error404Account} />
              <Route exact path='/admin/*' component={Error404Admin} />
              <Route exact path="/*">
    <Redirect to="/login" />
</Route>
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
